export default {
    computed: {
        /**
         * Get the default period to display in the select.
         *
         * @return {number}
         */
        defaultPeriod() {
            if (!this.productPrices.length) {
                return;
            }

            let defaultPeriod = this.productPrices.find(
                productPrice => productPrice.period == process.env.VUE_APP_DEFAULT_PERIOD
            );

            if (defaultPeriod) {
                return defaultPeriod.period;
            }

            return this.productPrices[0].period;
        },
        /**
         * Get the current period to display in the select.
         *
         * @return {number}
         */
        currentPeriod() {
            return this.defaultPeriod;
        },
        /**
         * Get the applicable price.
         *
         * @return {object}
         */
        applicablePrice() {
            if (!this.productPrices) {
                return;
            }

            return this.productPrices.find(productPrice => productPrice.period == this.currentPeriod);
        },
        /**
         * Get the product price based on the period.
         *
         * @return {number}
         */
        productPrice() {
            const applicablePrice = this.applicablePrice;

            if (!applicablePrice) {
                return;
            }

            if (typeof applicablePrice.promotion_price === 'number') {
                return applicablePrice.promotion_price;
            }

            if (typeof applicablePrice.discount_price === 'number') {
                return applicablePrice.discount_price;
            }

            return applicablePrice.regular_price;
        },

        /**
         * Get the product prolongation price based on the period.
         *
         * @return {number}
         */
        productProlongationPrice() {
            const applicablePrice = this.productProlongationPrices.find(
                productPrice => productPrice.period == this.currentPeriod
            );

            if (!applicablePrice) {
                return;
            }

            if (typeof applicablePrice.promotion_price === 'number') {
                return applicablePrice.promotion_price;
            }

            if (typeof applicablePrice.discount_price === 'number') {
                return applicablePrice.discount_price;
            }

            return applicablePrice.regular_price;
        },

        /**
         * Get the product promotion price based on the period.
         *
         * @return {number}
         */
        productPromotionPrice() {
            const applicablePrice = this.applicablePrice;

            if (!applicablePrice) {
                return;
            }

            return applicablePrice.promotion_price;
        },

        /**
         * Get the product price per month
         * @return {number}
         */
        monthPrice() {
            let price = this.productPrice;

            if (price === null) {
                return;
            }

            return price / this.currentPeriod;
        },
        /**
         * Get the gross product price based on the period.
         *
         * @return {number}
         */
        grossProductPrice() {
            const applicablePrice = this.applicablePrice;

            if (!applicablePrice) {
                return;
            }

            if (typeof applicablePrice.promotion_price === 'number') {
                return applicablePrice.promotion_price;
            }

            return applicablePrice.regular_price;
        }
    }
};
